"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _portal = require("../portal");
var _OverlayDestination = require("./OverlayDestination");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var lockScroll = function lockScroll(enabled) {
  if (document.body != null) {
    if (enabled) {
      document.body.style.setProperty('overflow', 'hidden');
    } else {
      document.body.style.removeProperty('overflow');
    }
  }
};
var Overlay = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2.default)(Overlay, _Component);
  function Overlay() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      open: !!_this.props.open
    };
    _this.onKeyDown = function (event) {
      if (_this.state.open && event.key === 'Escape') {
        _this.setClosed();
        return;
      }
      if (_this.props.handleKeyboardEvent) {
        _this.props.handleKeyboardEvent(event);
      }
    };
    _this.handleChange = function () {
      if (_this.props.handleChange) {
        _this.props.handleChange(_this.state);
      }
    };
    _this.toggleOpen = function () {
      return _this.setState(function (state) {
        return {
          open: !!state.open
        };
      }, _this.handleChange);
    };
    _this.setOpen = function () {
      return _this.setState({
        open: true
      }, _this.handleChange);
    };
    _this.setClosed = function () {
      return _this.setState({
        open: false
      }, _this.handleChange);
    };
    return _this;
  }
  var _proto = Overlay.prototype;
  _proto.componentDidMount = function componentDidMount() {
    document.addEventListener('keydown', this.onKeyDown);
    if (this.props.scrollLock && this.state.open) {
      lockScroll(true);
    }
  };
  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.state.open) {
      this.setState({
        open: nextProps.open
      });
    }
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (this.props.scrollLock && this.state.open !== prevState.open) {
      lockScroll(this.state.open);
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown);
    if (this.props.scrollLock && this.state.open) {
      lockScroll(false);
    }
  };
  _proto.render = function render() {
    var portalName = (0, _OverlayDestination.getPortalName)(this.props.name);
    var renderProps = {
      open: this.state.open,
      toggleOpen: this.toggleOpen,
      setOpen: this.setOpen,
      setClosed: this.setClosed
    };
    if (this.props.component) {
      return this.state.open ? /*#__PURE__*/_react.default.createElement(_portal.Portal, {
        into: portalName
      }, /*#__PURE__*/(0, _react.createElement)(this.props.component, renderProps)) : null;
    }
    if (this.props.render) {
      return this.state.open ? /*#__PURE__*/_react.default.createElement(_portal.Portal, {
        into: portalName
      }, this.props.render(renderProps)) : null;
    }
    if (typeof this.props.children === 'function') {
      return /*#__PURE__*/_react.default.createElement(_portal.Portal, {
        into: portalName
      }, this.props.children(renderProps));
    }
    return null;
  };
  return Overlay;
}(_react.Component);
Overlay.defaultProps = {
  open: false,
  name: null,
  handleChange: null,
  scrollLock: true
};
var _default = exports.default = Overlay;